/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineListModel,
    MachineListModelFromJSON,
    MachineListModelFromJSONTyped,
    MachineListModelToJSON,
} from './MachineListModel';

/**
 * 
 * @export
 * @interface MachineListModelPagedDataModel
 */
export interface MachineListModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof MachineListModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineListModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineListModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineListModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineListModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<MachineListModel>}
     * @memberof MachineListModelPagedDataModel
     */
    data?: Array<MachineListModel> | null;
}

export function MachineListModelPagedDataModelFromJSON(json: any): MachineListModelPagedDataModel {
    return MachineListModelPagedDataModelFromJSONTyped(json, false);
}

export function MachineListModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineListModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(MachineListModelFromJSON)),
    };
}

export function MachineListModelPagedDataModelToJSON(value?: MachineListModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(MachineListModelToJSON)),
    };
}

